import {
  Zap,
  BarChart3,
  Wifi,
  ShieldCheck,
  Users,
  Globe,
  Layers,
  Search,
  Lock,
} from "lucide-react";
import { motion } from "framer-motion";

const features = [
  {
    icon: Zap,
    title: "Acelera tus Ventas",
    description:
      "Elimina las colas y procesa transacciones en segundos. Nuestra interfaz intuitiva permite que tu equipo venda más rápido y sin errores.",
    color: "bg-blue-500",
  },
  {
    icon: Wifi,
    title: "Operación 100% Offline",
    description:
      "Tu negocio no se detiene si falla el internet. Gestiona ventas e inventario sin conexión; todos tus datos se sincronizan automáticamente de forma segura al recuperar la conexión.",
    color: "bg-rose-500",
  },
  {
    icon: Layers,
    title: "Adiós a las Pérdidas",
    description:
      "Recupera el control total de tu stock. Recibe alertas automáticas antes de agotar productos y detecta cualquier irregularidad al instante.",
    color: "bg-emerald-500",
  },
  {
    icon: ShieldCheck,
    title: "Cierres de Caja Perfectos",
    description:
      "Duerme tranquilo sabiendo que cada centavo está en su lugar. Automatiza el control de turnos y arqueos para eliminar las diferencias de dinero.",
    color: "bg-purple-500",
  },
  {
    icon: Users,
    title: "Fideliza a tus Clientes",
    description:
      "Convierte compradores ocasionales en clientes leales. Conoce sus preferencias y crea promociones personalizadas que los hagan volver.",
    color: "bg-indigo-500",
  },
  {
    icon: BarChart3,
    title: "Decisiones con Datos",
    description:
      "Deja de adivinar y empieza a crecer. Analiza tus ganancias y productos más vendidos en tiempo real para optimizar tu inversión.",
    color: "bg-orange-500",
  },
];

export default function Features() {
  return (
    <section
      id="features"
      className="py-16 sm:py-20 lg:py-24 xl:py-32 bg-slate-50/50 dark:bg-slate-900/20"
    >
      <div className="container px-4 mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-16 lg:mb-20 xl:mb-24">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-primary font-black tracking-[0.2em] uppercase text-xs mb-4 block"
          >
            Beneficios Exclusivos
          </motion.span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold font-display tracking-tight mb-4 sm:mb-6">
            Diseñado para que tu negocio{" "}
            <span className="text-gradient">nunca deje de crecer</span>
          </h2>
          <p className="text-base sm:text-lg text-slate-600 dark:text-slate-400 font-light px-4">
            No solo te damos herramientas, te damos la ventaja competitiva que
            necesitas para dominar tu mercado.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="p-6 sm:p-8 lg:p-10 rounded-2xl sm:rounded-3xl lg:rounded-[2.5rem] bg-white dark:bg-slate-800/50 border border-slate-100 dark:border-slate-800 hover:border-primary/20 hover:shadow-2xl hover:shadow-primary/5 transition-all group backdrop-blur-sm"
            >
              <div
                className={`w-12 h-12 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl ${feature.color} flex items-center justify-center mb-5 sm:mb-6 lg:mb-8 shadow-lg shadow-current/20 group-hover:scale-110 transition-transform`}
              >
                <feature.icon className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-3 lg:mb-4 font-display dark:text-white">
                {feature.title}
              </h3>
              <p className="text-sm sm:text-base text-slate-500 dark:text-slate-400 font-light leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
